const metabolismData = [
    {
        id: 1,
        name: "سن",
        unit: "سال"
    },
    {
        id: 2,
        name: "وزن",
        unit: "کیلوگرم"
    },
    {
        id: 3,
        name: "قد",
        unit: "سانتی متر"
    }
]

export default metabolismData